import { create } from 'zustand';

const initialStoreValues = {
  localisationData: null,
};

export const useLocalisationStore = create()(() => initialStoreValues);

export const setLocalisationData = (data) => {
  useLocalisationStore.setState({
    localisationData: data,
  });
};
